export default __webpack_public_path__ + "static/media/do-1@3x.4c6ab7be.jpg";